import { fmtAgo } from './format.ts'

// Maintenance in words: who does what, for the top bar and wherever a session is named.

interface SessionWords { who: string; what: string; explicit?: boolean; started_at: string }

// sessionWords: "Claude, NIC firmware update on xcc1-gw-02"
export function sessionWords(s: { who: string; what: string }): string {
  return `${s.who}, ${s.what}`
}

// sessionAge: only for what someone started by hand and has to end, so that a forgotten
// one shows
export function sessionAge(s: SessionWords): string {
  return s.explicit ? `started ${fmtAgo(s.started_at)}` : ''
}

// topBarWords: the state in the top bar. text at full width, phone at phone width, title
// on hover, age apart from the text so that a long text does not cut it off; zones: the
// zones that are busy without a session (a rollout, a soak time).
export function topBarWords(sessions: SessionWords[], zones: { label: string; activities: string[] }[]): { busy: boolean; text: string; phone: string; title: string; age?: string } {
  const line = (s: SessionWords) => [sessionWords(s), sessionAge(s)].filter(Boolean).join(' · ')
  const details = [...sessions.map(line), ...zones.flatMap((z) => z.activities)].join('\n')
  if (sessions.length === 1) return { busy: true, text: `Maintenance: ${sessionWords(sessions[0])}`, phone: sessionWords(sessions[0]), title: details, age: sessionAge(sessions[0]) }
  if (sessions.length > 1) return { busy: true, text: `Maintenance: ${sessions.length} sessions`, phone: `${sessions.length} maintenance sessions`, title: details }
  if (zones.length > 0) return { busy: true, text: `Maintenance: ${zones.map((z) => z.label).join(', ')}`, phone: 'Maintenance', title: details }
  return { busy: false, text: 'Maintenance: none running', phone: 'No maintenance', title: 'No change runs in any zone' }
}
